import { styled, TextField } from "@mui/material";
import { MuiChipsInput } from "mui-chips-input";

// Hide the native number-input spinners so the up/down arrows aren't shown.
const hideNumberSpinners = {
    '& input[type=number]': {
        MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
};

// Hiding the spinners with CSS only removes the arrows — a focused number
// input can still be stepped with the mouse wheel and the up/down arrow keys.
// React registers onWheel as a passive listener (so preventDefault is ignored
// there), so attach native listeners directly on the input to kill both ways
// of accidentally incrementing/decrementing a rate while configuring.
const disableNumberInputStepping = (node) => {
    if (!node) return;
    const input = node.querySelector?.("input[type=number]");
    if (!input || input.dataset.noStepBound) return;
    input.dataset.noStepBound = "1";
    input.addEventListener("wheel", (e) => e.preventDefault(), { passive: false });
    input.addEventListener("keydown", (e) => {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault();
    });
};

const StyledCssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            // borderColor: '#999',
            border: "3px solid #999",
        },
    },
    ...hideNumberSpinners,
});

export const CssTextField = (props) => (
    <StyledCssTextField {...props} ref={disableNumberInputStepping} />
);

const StyledUpdatableField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            // borderColor: '#c2c2c2',
            border: "3px solid #c2c2c2",
        },
    },
    ...hideNumberSpinners,
});

export const UpdatableField = (props) => (
    <StyledUpdatableField {...props} ref={disableNumberInputStepping} />
);

export const ChipsInputStyled = styled(MuiChipsInput)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: "3px solid #999",
        },
    },
});
